import request from '@/utils/request'
/**
 * 权限(用户、权限、角色、公司)相关得api js
 */
// 获取所有得用户列表
export function getApiUserList(params) {
  return request({
    url: '/auth/user/list',
    method: 'post',
    data: params
  })
}
// 添加/修改用户
export function addOrUpdateUserApi(params) {
  return request({
    url: '/auth/user/save',
    method: 'post',
    data: params
  })
}
// 用户密码重置
export function resetUserPwdApi(params) {
  return request({
    url: '/auth/user/resetPassword',
    method: 'get',
    params
  })
}
// 用户是否存在
export function userExistApi(params) {
  return request({
    url: '/auth/user/queryNameExist',
    method: 'get',
    params
  })
}
// 用户密码修改
export function updatePwd(params) {
  return request({
    url: '/auth/user/updPwd',
    method: 'put',
    data: params
  })
}
// 用户头像-上传本地
export function userPhotoUpdate(params) {
  return request({
    url: '/user/profiles',
    method: 'put',
    data: params
  })
}
// 查询角色列表
export function listRoleApi(params) {
  return request({
    url: '/auth/role/list',
    method: 'get',
    params
  })
}
// 添加/编辑角色
export function addOrUpdateRoleApi(params) {
  return request({
    url: '/auth/role/saveOrUpdate',
    method: 'post',
    data: params
  })
}
// 删除角色
export function delRoleApi(params) {
  return request({
    url: '/auth/role/delete',
    method: 'delete',
    params
  })
}
// 组织根节点列表
export function getTopOrgList(params) {
  return request({
    url: '/auth/company/topList',
    method: 'get',
    params
  })
}
// 组织
export function listCompany(params) {
  return request({
    url: '/auth/company/list',
    method: 'post',
    data: params
  })
}
// 添加组织
export function addCompanyApi(params) {
  return request({
    url: '/auth/company/save',
    method: 'post',
    data: params
  })
}
// 编辑组织
export function editCompanyApi(params) {
  return request({
    url: '/auth/company/update',
    method: 'put',
    data: params
  })
}
// 校验组织是否存在
export function existCompanyApi(params) {
  return request({
    url: '/auth/company/exists',
    method: 'post',
    data: params
  })
}
// 查询所有得权限
export function listAllPermission(params) {
  return request({
    url: '/auth/permission/getFunTree',
    method: 'post',
    data: params
  })
}
// 获取所有的菜单
export function getEffectiveMenu(params) {
  return request({
    url: '/auth/permission/getMenuTree',
    method: 'post',
    data: params
  })
}
// 添加/编辑权限
export function addOrEditPermissionApi(params) {
  return request({
    url: '/auth/permission/saveOrUpdate',
    method: 'post',
    data: params
  })
}
// 查询当前用户组织下可查看角色
export function getCurUserValidRole(params) {
  return request({
    url: '/distributor-info/getCurUserValidRole',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/privilege/privilege.js